import React from 'react'

const Arrow = props => (
  <svg width="10px" height="10px" viewBox="0 0 10 4" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Path 13</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Nawigacja-NEW_2" transform="translate(-334.000000, -99.000000)" stroke="#28D88C">
              <polyline id="Path-13" points="335 99 338.903932 102.903932 342.807864 99"></polyline>
          </g>
      </g>
  </svg>
)

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/SVG/ActiveArrow.js